import { fetchQuery, localize } from "clariah/utils/sanity";
import { newsEventsOverviewQuery as query } from "clariah/utils/staticHelpers";
import {
  BLOG_TYPE,
  EVENT_TYPE,
  NEWS_EVENTS_OVERVIEW_TYPE,
  NEWS_TYPE,
} from "clariah/utils/constants";
import { createInternalHref } from "clariah/utils/createInternalHref";
import { NL, EN } from "shared/utils/constants";
import { undefinedToNull } from "shared/utils/undefinedToNull";
import { getYesterdayISOString } from "shared/utils/formatDate";
import { PreviewSuspense } from "next-sanity/preview";
import { NewsEventsOverviewPagePreview } from "clariah/containers/NewsEventsOverviewPagePreview";
import { NewsEventsOverviewPage } from "clariah/containers/NewsEventsOverviewPage";
import { useRouter } from "next/router";

export async function getStaticProps({ preview = false, locale }) {
  if (locale !== EN) {
    return { notFound: true };
  }

  const mirrorPath = createInternalHref({
    href: "",
    locale: locale === NL ? EN : NL,
    type: NEWS_EVENTS_OVERVIEW_TYPE,
  });

  const params = {
    mirrorPath,
    overviewType: NEWS_EVENTS_OVERVIEW_TYPE,
    blogType: BLOG_TYPE,
    newsType: NEWS_TYPE,
    eventType: EVENT_TYPE,
    yesterday: getYesterdayISOString(),
  };

  if (preview) {
    return {
      props: { preview, data: { params } },
    };
  }

  const data = await fetchQuery({
    preview,
    query,
    params,
  });

  return {
    props: {
      preview,
      data: {
        mirrorPath,
        ...undefinedToNull(localize(data, locale)),
      },
    },
  };
}

const PageToExport = ({ preview, data }) => {
  const { locale } = useRouter();

  return preview ? (
    <PreviewSuspense>
      <NewsEventsOverviewPagePreview
        query={query}
        params={data.params}
        locale={locale}
      />
    </PreviewSuspense>
  ) : (
    <NewsEventsOverviewPage {...data} />
  );
};

export default PageToExport;
